"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnterScoreBodyToJSON = exports.EnterScoreBodyFromJSONTyped = exports.EnterScoreBodyFromJSON = void 0;
const runtime_1 = require("../runtime");
function EnterScoreBodyFromJSON(json) {
    return EnterScoreBodyFromJSONTyped(json, false);
}
exports.EnterScoreBodyFromJSON = EnterScoreBodyFromJSON;
function EnterScoreBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hole': json['hole'],
        'score': json['score'],
        'playerID': !runtime_1.exists(json, 'playerID') ? undefined : json['playerID'],
    };
}
exports.EnterScoreBodyFromJSONTyped = EnterScoreBodyFromJSONTyped;
function EnterScoreBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hole': value.hole,
        'score': value.score,
        'playerID': value.playerID,
    };
}
exports.EnterScoreBodyToJSON = EnterScoreBodyToJSON;
